import React, { useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { useNavigate } from "react-router-dom";
import { images } from "../../Assets/images";
import storage from "../../Assets/js/Global";

const VerifyOtp = () => {
  const {
    email,
    userData,
    updateUserData,
    verifyOTP,
    resendEmailOTP,
    timer,
    resendDisabled,
    translatedLabels,
    logoUrl,
  } = useContext(GlobalContext);
  const authLabel = translatedLabels?.auth;

  const handleSubmit = (e) => {
    e.preventDefault();
    verifyOTP();
  };

  const navigate = useNavigate();

  const handleNavigate = () => {
    let userModule = storage.get("UserModule");

    if (userModule === "Signup") {
      navigate("/login");
    } else {
      navigate("/forgot-password");
    }
  };

  return (
    <>
      <section id="forgotVerifyOTPPage" className="login-section-bg">
        <div className="container-main">
          <div className="text-center">
            <div className="d-flex justify-content-center">
              <div className="app-logo">
                <img
                  src={logoUrl || images.appLogo}
                  alt="app-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = images.appLogo;
                  }}
                />
              </div>
            </div>
          </div>

          <h3 className="text-center my-3">
            {authLabel?.verification_code?.label_value || "Verfication Code"}
          </h3>
          <div className="form-group text-center mt-2">
            <p className="form-label">
              <span>{authLabel?.your_email?.label_value || "Your Email"}</span>:{" "}
              <span className="fw-semibold" id="user-email">
                {email}{" "}
                <span onClick={handleNavigate} className="text-primary">
                  <i className="fa-solid fa-pencil"></i>
                </span>
              </span>
            </p>
          </div>
          <p className="text-center fs-14px text-muted">
            {authLabel?.enter_email_code?.label_value ||
              "Please enter the 6-digit code sent to your email"}
          </p>
          <form onSubmit={handleSubmit}>
            <div className="otp-container">
              <input
                type="text"
                maxLength="6"
                className="otp-input"
                placeholder="------"
                value={userData.otp}
                onChange={(e) => updateUserData("otp", e.target.value)}
              />
            </div>
            <p className="fw-semibold text-center">
              {authLabel?.didnt_receive_code?.label_value ||
                "Didn’t receive the verification code?"}

              <span
                onClick={resendEmailOTP}
                className="ms-1 text-decoration-none fw-semibold text-primary"
                style={{
                  cursor: resendDisabled ? "not-allowed" : "pointer",
                  opacity: resendDisabled ? 0.6 : 1,
                  pointerEvents: resendDisabled ? "none" : "auto",
                }}
              >
                {authLabel?.resend?.label_value || "Resend"}
              </span>
            </p>
            {resendDisabled && (
              <p className="text-center fst-italic timer-part">
                {authLabel?.resend_otp_in?.label_value || "Resend OTP in"}{" "}
                <span id="countdownTimer" className="fw-semibold text-primary">
                  00:{timer < 10 ? `0${timer}` : timer} Sec
                </span>
              </p>
            )}
            <div className="mt-4 text-center">
              <button
                onClick={verifyOTP}
                type="button"
                className="btn btn-primary"
              >
                {authLabel?.verify?.label_value || "Verify"}
              </button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default VerifyOtp;
